import './styled.css';
import Banner from '../../assets/images/banner.webp';

export default function Header() {
  return (
    <div className='d-flex justify-content-center mb-5'>
      <img
        alt='Banner do evento'
        src={"https://s3.amazonaws.com/bucket.app.eventos/gallery/da604eb2-ce6b-414c-9db4-c080664e6bc4/2025/9dae1e79-2d5a-471b-81ce-36bb18d5d174.webp?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=2141282483&Signature=GqQnIlVBBW27Wxh0e%2FnM4l1nCGY%3D"}
        className='header-img'
      />
    </div>
  );
}
export function BannerLogin() {
  return (
    <div className='d-flex justify-content-center mb-5 mt-5'>
      <img
        alt='Banner do evento'
        src={"https://s3.amazonaws.com/bucket.app.eventos/gallery/da604eb2-ce6b-414c-9db4-c080664e6bc4/2025/9dae1e79-2d5a-471b-81ce-36bb18d5d174.webp?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=2141282483&Signature=GqQnIlVBBW27Wxh0e%2FnM4l1nCGY%3D"}
        className='header-img'
      />
    </div>
  );
}
